export const passwordForm = [
  {
    type: 'password',
    label: 'NEW PASSWORD',
    dbField: 'password',
    rules: [
      { required: true, message: 'This field is required' },
      {
        validator(_, value) {
          if (!value) {
            return Promise.resolve()
          }
          if (value.length < 14 || value.length > 30) {
            return Promise.reject(
              new Error('Password must be between 14 and 30 characters')
            )
          }
          if (!/(?=.*[a-z])/.test(value)) {
            return Promise.reject(
              new Error('Password must contain at least one lowercase letter')
            )
          }
          if (!/(?=.*[A-Z])/.test(value)) {
            return Promise.reject(
              new Error('Password must contain at least one uppercase letter')
            )
          }
          if (!/(?=.*\d)/.test(value)) {
            return Promise.reject(
              new Error('Password must contain at least one number')
            )
          }
          if (!/(?=.*[@$!%*?&])/.test(value)) {
            return Promise.reject(
              new Error('Password must contain at least one special character (@$!%*?&)')
            )
          }
          return Promise.resolve()
        }
      }
    ]
  },
  {
    type: 'password',
    label: 'VERIFY NEW PASSWORD',
    dbField: 'password2',
    dependencies: ['password'],
    rules: [
      { required: true, message: 'This field is required' },
      ({ getFieldValue }) => ({
        validator(_, value) {
          if (!value || getFieldValue('password') === value) {
            return Promise.resolve()
          }
          return Promise.reject(
            new Error('The two passwords that you entered do not match!')
          )
        }
      })
    ]
  }
]
